import { Asterisk } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
export default function Marquee() {
  const { t } = useLanguage();
  return <div className="studio-marquee" data-testid="studio-marquee"><div className="marquee-track">{[0, 1].map(copy => <div key={copy} aria-hidden={copy === 1} className="marquee-group">{t("marquee").map((item, i) => <span key={i}>{item}<Asterisk size={23} strokeWidth={1.2} /></span>)}</div>)}</div></div>;
}